module.exports = __webpack_public_path__ + "vn.svg?57857a74f1b844d3489643a021afd0b9";